<template>
  <MainLayout>
    <div id="contents">
      <ProductDetail />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import ProductDetail from '@/components/product/ProductDetail.vue';

export default {
  name: 'ProductDetailView',
  components: {
    MainLayout,
    ProductDetail,
  },
};
</script>
